import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "143",
  height: "94",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#94CBFC",
      d: "M71.5 0v20M71.5 25v20M49 22.5h20M74 22.5h20"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#62ADF8",
      d: "M120.5 0v20M120.5 25v20M98 22.5h20M123 22.5h20"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#94CBFC",
      d: "M22.5 49v20M22.5 74v20M0 71.5h20M25 71.5h20M120.5 49v20M120.5 74v20M98 71.5h20M123 71.5h20"
    }, null, -1)
  ]))]))
}
export default { render: render }